import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    addressInfo: {}, //位置信息
    fileAccepData: [], //图片附件数据
    videofileAccepData: [], //视频附件数据
    userMobile: '' //用户手机号
  },
  mutations: {},
  actions: {},
  modules: {}
})
